const getters = {
  visibleColumns: state => {
    return state.columns.filter(x => x.showColumn);
  },

  dateRange: state => state.dateRange,
};

export default getters;
